import { getFromLocalStorage, removeFromLocalStorage } from './localStorage';

const DEFAULT_DASHBOARD_ROUTE = '/dashboard/learners';

// Cache the result within one synchronous execution cycle so that
// React StrictMode's double-render doesn't consume the redirect twice.
let syncCache: string | null = null;

export default function getDefaultDashboardRoute() {
  if (syncCache !== null) {
    return syncCache;
  }

  const redirect = getFromLocalStorage('redirect');
  if (redirect) {
    console.log('Redirect found:', redirect);
    removeFromLocalStorage('redirect');
    syncCache = redirect;
  } else {
    console.log('No redirect found, returning to', DEFAULT_DASHBOARD_ROUTE);
    syncCache = DEFAULT_DASHBOARD_ROUTE;
  }

  // Clear the cache after the current synchronous batch so subsequent
  // independent calls (e.g. clicking a button later) read fresh state.
  Promise.resolve().then(() => {
    syncCache = null;
  });

  return syncCache ?? DEFAULT_DASHBOARD_ROUTE;
}
